/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Row, Col, Form, Container } from 'reactstrap';
import Checkbox from 'react-three-state-checkbox';
import Icon from '../../../common/containers/icon';
const OptionNestedPickerFieldOptions = ({
  options,
  onSelect,
  onForwardSelect,
  showIcon,
  className: _className = '',
  showCheck: _showCheck = true
}) => /*#__PURE__*/React.createElement(Container, {
  style: {
    maxHeight: 500,
    overflow: 'auto',
    paddingTop: 10,
    paddingBottom: 10
  }
}, /*#__PURE__*/React.createElement(Form, null, options.map((option, index) => /*#__PURE__*/React.createElement("span", {
  key: option.identifier
}, /*#__PURE__*/React.createElement(Row, {
  className: `t-onpo-${_className} t-onpo-${kebabCase(option.title)}`,
  style: {
    cursor: 'pointer'
  }
}, /*#__PURE__*/React.createElement(Col, {
  md: option.hasChildren ? 9 : 12,
  onClick: () => onSelect(option)
}, _showCheck && /*#__PURE__*/React.createElement(Checkbox, {
  className: `t-onpfo-checkbox-${kebabCase(option.identifier)}`,
  "data-testid": `t-onpfo-checkbox-${kebabCase(option.identifier)}`,
  style: {
    marginRight: 5
  },
  checked: option._isSelected
}), /*#__PURE__*/React.createElement("span", null, option.title)), option.hasChildren ? /*#__PURE__*/React.createElement(Col, {
  md: 3,
  className: `t-onpo-forward-${kebabCase(option.title)}`,
  style: {
    textAlign: 'right'
  },
  onClick: () => onForwardSelect(option)
}, showIcon && option._isSelected ? /*#__PURE__*/React.createElement(Icon, {
  glyph: "info-circle"
}) : null, /*#__PURE__*/React.createElement(Icon, {
  glyph: "chevron-right"
})) : null), option._crumbs || option.subtitle ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
  md: 12
}, /*#__PURE__*/React.createElement("small", null, option.subtitle || option._crumbs))) : null, index === options.length - 1 ? undefined : /*#__PURE__*/React.createElement("hr", {
  style: {
    marginTop: 5,
    marginBottom: 5
  }
})))));
OptionNestedPickerFieldOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  onForwardSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  showIcon: PropTypes.bool.isRequired,
  showCheck: PropTypes.bool
};
export default OptionNestedPickerFieldOptions;